import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CMSListRes;
export const CMSListTodo = createAsyncThunk('CMSList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin_cms_page_list',
            data: {
                
                "page_type": data
            },
            headers: { "Content-Type": "application/json" }
        })
        return CMSListRes = res.data

    } catch (error) {
        return CMSListRes = error.response.data
    }
})


const CMSListSlice = createSlice({
    name: 'CMSList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CMSListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('CMSList', state.data.response)
        });
        builder.addCase(CMSListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CMSListSlice.reducer; 